import { Currency } from '../../../constants';
import {
  WoocommercePaymentMethod,
  type WoocommercePaymentMethodValue,
} from '../../../constants/woocommerce/woocommerce';
import type {
  BillingAddress,
  ShippingAddress,
  WooCommerceLineItem,
  ShippingLine,
  WooCommerceOrderResponse,
} from '../../../model/woocommerce/woocommerce';

export interface CreateWooCommerceOrderRequest {
  paymentMethod: WoocommercePaymentMethodValue;
  customerId?: number;
  paymentMethodTitle: string;
  setPaid?: boolean;
  total: number;
  currency: Currency;
  billing: BillingAddress;
  shipping: ShippingAddress;
  lineItems: WooCommerceLineItem[];
  shippingLines?: ShippingLine[];
  paymentProcessInfo: {
    stripePaymentIntentId?: string;
  };
}

export type CreateWooCommerceOrderResponse = WooCommerceOrderResponse;
